import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { UrlBuilderService } from '../../common/services/url-builder.service';
import { DashboardItem } from '../../dashboards/models/dashboard-item';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class DefaultDashboardLayoutService {

  constructor(
    private urlBuilder: UrlBuilderService,
    private http: HttpClient) {
  }

  get(profileId: number, dashboardIdentifier: string): Observable<DashboardItem[]> {
    const url = this.urlBuilder.getUrl('defaultdashboardlayout');
    const params = new HttpParams()
      .set('profileId', String(profileId))
      .set('dashboardIdentifier', dashboardIdentifier);
    return this.http
      .get<DashboardItem[]>(url, { params: params }).pipe(
        map(layoutItems => layoutItems || [])
      );
  }

  setDashboardItems(profileId: number, dashboardIdentifier: string, items: DashboardItem[]) {
    const url = this.urlBuilder.getUrl('defaultdashboardlayout');
    return this
      .http
      .put<DashboardItem[]>(url, { DashboardIdentifier: dashboardIdentifier, ProfileId: profileId, Items: items });
  }

}
